import {Component, Input} from '@angular/core';
import {ProyectoItem, ProyectoTramiteItem} from '../../../interfaces/proyecto.interface';
import {ProyectoService} from "../../services/proyecto.service";
import {SdetInterface} from "../../../tramites/components/interfaces/sdet.interface";
import Swal from "sweetalert2";
import {TramiteService} from "../../../tramites/services/tramite.service";
import {Router} from "@angular/router";
import {LoginServices} from "../../../../auth/login/services/login.service";

@Component({
    selector: 'app-info-tramites-proyecto',
    templateUrl: './info-tramites-proyecto.component.html',
    styleUrls: ['./info-tramites-proyecto.component.css']
})
export class InfoServiciosProyectoComponent {
    visible: boolean = false;
    public datosCargados: boolean = false;
    tramitesPorProyecto: ProyectoTramiteItem[] = []
    constructor(private proyecto: ProyectoService, private tramiteService: TramiteService, public router: Router, protected loginServices: LoginServices) {
    }
    showDialog() {
        this.visible = true;
        this.getRequisitos()
    }
    hiddeDialog() {
        this.visible = false;
        this.datosCargados = false;
    }
    private getRequisitos() {
        this.proyecto.getTramitesProyectos(this.idProyecto!)
            .subscribe({
                next: (result) => {
                    if (result.status == 200) {
                        this.datosCargados = true
                        this.tramitesPorProyecto = result.body!
                    }
                },
                error: (error) => {
                    console.log(error)
                }
            });
    }
    @Input()
    public nombreProyecto?: string = '';
    @Input()
    selected?: ProyectoItem | null = null;
    @Input()
    idProyecto: number | null = null
    @Input()
    cantidadTramites?: number | null = null
    title() {
        let tituloDialog = ''
        if (this.selected) {
            tituloDialog = `TRAMITES SOLICITADOS - SOLICITUD #${this.selected.numeroExpediente}`
        }
        return tituloDialog;
    }
    /**
     * Redirecciona al formulario correspondiente.
     */
    initFormTramites(event: Event,tramiteItem:ProyectoTramiteItem){
        if(tramiteItem == null){
            console.log("datos invalidos nulos")
            return;
        }
        const sdet: SdetInterface = {
            codigoInstitucion: Number.parseFloat(tramiteItem.codigoInstitucion),
            idTramite: Number.parseFloat(tramiteItem.idTramite),
            codigoProyecto: tramiteItem.idProyecto,
            codigoSolicitud: tramiteItem.idSolicitud,
            usuario: this.loginServices.session()?.perfil.usuario,
            idFase: Number.parseFloat(tramiteItem.idFase)
        };
        this.tramiteService.initFormSdet(sdet).subscribe({
            next: (result) => {
                const responseBody = result.body;
                if (Array.isArray(responseBody)) {
                    let item = responseBody[0];
                    this.router
                        .navigate([
                            `${item.ruta}${tramiteItem.idTramite}/${tramiteItem.idProyecto}`,
                        ])
                        .then();
                } else {
                    let error = `Tramite #${sdet.idTramite} no posee formulario configurado.`;
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: error,
                        showDenyButton: true,
                        showConfirmButton: false,
                        denyButtonText: `Ok`,
                    }).then((result) => {
                        console.error(error);
                    });
                }
            },
            error: (error) => {
                console.error(error);
                let text = error.mensaje;
                if (error.error && error.error.mensaje) {
                    text = error.error.mensaje; // Extract the custom message
                } else if (error.message) {
                    text = error.message; // Fallback to the general error message
                }
                if (text.includes('api')) {
                    text = 'Ocurrió un error al procesar, intente mas tarde';
                }
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: text
                        ? text
                        : 'Ocurrió un error al procesar, intente mas tarde',
                    showDenyButton: true,
                    showConfirmButton: false,
                    denyButtonText: `Ok`,
                });
                console.log(error);
            },
            complete: () => {
            },
        });
    }
}
